import Navbar from './Navbar.jsx'
import Footer from './Footer.jsx'
import ComparisonTray from './ComparisonTray.jsx'
import PwaInstallBanner from './PwaInstallBanner.jsx'
import AffordabilitySidebar from './AffordabilitySidebar.jsx'

const Layout = ({ children, authEnabled }) => {
  return (
    <div className="app-shell">
      <PwaInstallBanner />
      <Navbar authEnabled={authEnabled} />
      <main>{children}</main>
      <Footer />
      <ComparisonTray />
      <AffordabilitySidebar />
    </div>
  )
}

export default Layout
